(() => {
  const root = document.querySelector('[data-newsroom-page]');
  if (!root) return;
  const mobileMenu = root.querySelector('[data-newsroom-mobile-menu]');
  const hero = root.querySelector('[data-newsroom-hero]');
  const introStage = root.querySelector('[data-newsroom-stage-one]');
  const storyStage = root.querySelector('[data-newsroom-stage-two]');
  const blogHub = root.querySelector('[data-blog-hub]');
  const pageHeader = root.querySelector('.newsroom-page-header');

  // Split intro words + story heading/body into per-letter spans for the scrubbed reveal.
  const splitIntoChars = (el, className, wordIndex) => {
    if (!el || el.dataset.split) return;
    const text = el.textContent.trim();
    el.textContent = '';
    el.setAttribute('aria-label', text);
    const keepWordsTogether = className === 'newsroom-hero__story-char';
    let index = 0;
    text.split(/(\s+)/).forEach((token) => {
      if (/^\s+$/.test(token)) {
        el.appendChild(document.createTextNode(token));
        return;
      }

      const word = keepWordsTogether ? document.createElement('span') : el;
      if (keepWordsTogether) {
        word.className = 'newsroom-hero__story-word';
        el.appendChild(word);
      }

      [...token].forEach((char) => {
        const span = document.createElement('span');
        span.className = className;
        if (wordIndex !== undefined) span.style.setProperty('--w', wordIndex);
        span.style.setProperty('--i', index);
        span.textContent = char;
        word.appendChild(span);
        index += 1;
      });
    });
    el.style.setProperty('--n', index);
    el.dataset.split = 'true';
  };

  root.querySelectorAll('.newsroom-hero__intro-word').forEach((word, wordIndex) => {
    splitIntoChars(word, 'newsroom-hero__intro-char', wordIndex);
    word.classList.add('is-split');
  });
  if (storyStage) {
    splitIntoChars(storyStage.querySelector('h2'), 'newsroom-hero__story-char');
    splitIntoChars(storyStage.querySelector('p'), 'newsroom-hero__story-char');
  }

  const updateHeroStage = () => {
    if (!hero || !introStage || !storyStage || root.dataset.activeView !== 'news') return;
    const rect = hero.getBoundingClientRect();
    const travel = Math.max(1, hero.offsetHeight - window.innerHeight);
    const progress = Math.min(1, Math.max(0, -rect.top / travel));
    const ease = (value) => value * value * (3 - (2 * value));
    const range = (start, end) => ease(Math.min(1, Math.max(0, (progress - start) / (end - start))));

    hero.dataset.newsroomStage = progress >= .5 ? 'story' : 'intro';

    // Intro window (1 at the top → 0 once scrolled past) + unified premium fade-out.
    const introExit = range(.2, .5);
    const introWindow = 1 - introExit;
    hero.style.setProperty('--newsroom-intro-window', introWindow.toFixed(4));
    hero.style.setProperty('--newsroom-intro-y', String(-16 * introExit));
    hero.style.setProperty('--newsroom-intro-scale', String(1 + .06 * introExit));
    hero.style.setProperty('--newsroom-intro-blur', String(8 * introExit));

    // Story window (0 → 1 as it enters) with the same premium fade.
    const storyIn = range(.5, .8);
    hero.style.setProperty('--newsroom-story-window', storyIn.toFixed(4));
    hero.style.setProperty('--newsroom-story-y', String(14 - 14 * storyIn));
    hero.style.setProperty('--newsroom-story-scale', (1.05 - .05 * storyIn).toFixed(4));
    hero.style.setProperty('--newsroom-story-blur', String(8 - 8 * storyIn));

    // Parallax depth on the pinned scene.
    hero.style.setProperty('--newsroom-image-scale', (1.12 - .12 * progress).toFixed(4));
    hero.style.setProperty('--newsroom-image-y', (3 - 3 * progress).toFixed(4));
    hero.style.setProperty('--newsroom-shade-extra', (0.28 * progress).toFixed(4));
  };

  const setMenuOpen = (open) => {
    if (!mobileMenu) return;
    mobileMenu.hidden = !open;
    document.querySelectorAll('[data-newsroom-menu-toggle]').forEach((button) => {
      button.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  };

  const setHeaderHeight = () => {
    if (!pageHeader) return;
    document.documentElement.style.setProperty('--newsroom-header-height', pageHeader.offsetHeight + 'px');
  };

  const updateHeaderState = () => {
    if (!pageHeader) return;
    if (root.dataset.activeView !== 'news') {
      pageHeader.classList.remove('is-scrolled');
      return;
    }
    pageHeader.classList.toggle('is-scrolled', window.scrollY > window.innerHeight * 0.9);
  };

  const selectView = (view, updateHash) => {
    const panel = root.querySelector('[data-newsroom-view="' + view + '"]');
    if (!panel) return;

    root.dataset.activeView = view;
    document.documentElement.classList.toggle('newsroom-view-news', view === 'news');
    document.documentElement.classList.toggle('newsroom-view-blog', view === 'blog');

    root.querySelectorAll('[data-newsroom-view]').forEach((item) => {
      item.hidden = item !== panel;
    });
    document.querySelectorAll('[data-newsroom-tab]').forEach((tab) => {
      const isActive = tab.dataset.newsroomTab === view;
      tab.classList.toggle('active', isActive);
      tab.setAttribute('aria-current', isActive ? 'page' : 'false');
    });

    if (updateHash) {
      history.replaceState(null, '', '#' + view);
      window.scrollTo(0, 0);
    }
    updateHeroStage();
    updateHeaderState();
    window.GoldenMateFooterSyncBackground?.();
  };

  const viewFromHash = window.location.hash.slice(1);
  selectView(viewFromHash === 'news' ? 'news' : 'blog', false);
  setHeaderHeight();
  updateHeaderState();

  document.querySelectorAll('[data-newsroom-tab]').forEach((tab) => {
    tab.addEventListener('click', (event) => {
      event.preventDefault();
      selectView(tab.dataset.newsroomTab, true);
      setMenuOpen(false);
    });
  });

  document.querySelectorAll('[data-newsroom-menu-toggle]').forEach((button) => {
    button.addEventListener('click', () => {
      setMenuOpen(mobileMenu.hidden);
    });
  });

  window.addEventListener('hashchange', () => {
    const hash = window.location.hash.slice(1);
    selectView(hash === 'news' ? 'news' : 'blog', false);
  });

  let heroTicking = false;
  window.addEventListener('scroll', () => {
    if (heroTicking) return;
    heroTicking = true;
    window.requestAnimationFrame(() => {
      updateHeroStage();
      updateHeaderState();
      heroTicking = false;
    });
  }, { passive: true });
  window.addEventListener('resize', () => {
    updateHeroStage();
    setHeaderHeight();
  });
  updateHeroStage();

  const storyRail = root.querySelector('[data-newsroom-stories]');
  if (storyRail) {
    let storyDragging = false;
    let storyMoved = false;
    let storyStart = 0;
    let storyScroll = 0;
    storyRail.addEventListener('pointerdown', (event) => {
      storyDragging = true;
      storyMoved = false;
      storyStart = event.clientX;
      storyScroll = storyRail.scrollLeft;
      storyRail.classList.add('is-dragging');
    });
    storyRail.addEventListener('pointermove', (event) => {
      if (!storyDragging) return;
      if (!storyMoved && Math.abs(event.clientX - storyStart) > 6) {
        storyMoved = true;
      }
      if (storyMoved) {
        event.preventDefault();
        storyRail.scrollLeft = storyScroll - (event.clientX - storyStart);
      }
    });
    const stopStoryDragging = () => {
      storyDragging = false;
      storyRail.classList.remove('is-dragging');
    };
    storyRail.addEventListener('pointerup', stopStoryDragging);
    storyRail.addEventListener('pointercancel', stopStoryDragging);
    storyRail.addEventListener('dragstart', (event) => {
      event.preventDefault();
    });
    storyRail.addEventListener('click', (event) => {
      if (storyMoved) { event.preventDefault(); event.stopPropagation(); storyMoved = false; }
    }, true);

    const storyDots = root.querySelector('[data-newsroom-stories-dots]');
    if (storyDots) {
      const dots = [...storyDots.children];
      const updateStoryDots = () => {
        const max = Math.max(1, storyRail.scrollWidth - storyRail.clientWidth);
        const index = Math.round(storyRail.scrollLeft / max * (dots.length - 1));
        dots.forEach((dot, i) => dot.classList.toggle('is-active', i === index));
      };
      storyRail.addEventListener('scroll', updateStoryDots, { passive: true });
      window.addEventListener('resize', updateStoryDots);
      updateStoryDots();
    }
  }

  if (blogHub) {
    const carousel = blogHub.querySelector('[data-blog-carousel]');
    const carouselPrev = blogHub.querySelector('[data-blog-carousel-prev]');
    const carouselNext = blogHub.querySelector('[data-blog-carousel-next]');
    const carouselProgress = blogHub.querySelector('[data-blog-carousel-progress]');
    const filters = [...blogHub.querySelectorAll('[data-blog-filter]')];
    const cards = [...blogHub.querySelectorAll('[data-blog-grid] [data-blog-card]')];
    const groups = [...blogHub.querySelectorAll('[data-blog-group]')];
    const empty = blogHub.querySelector('[data-blog-empty]');
    const count = blogHub.querySelector('[data-blog-count]');

    const moveCarousel = (direction) => {
      if (!carousel) return;
      const distance = carousel.clientWidth * .72;
      carousel.scrollBy({ left: direction * distance, behavior: 'smooth' });
    };
    carouselPrev?.addEventListener('click', () => moveCarousel(-1));
    carouselNext?.addEventListener('click', () => moveCarousel(1));
    carousel?.addEventListener('keydown', (event) => {
      if (event.key === 'ArrowLeft') { event.preventDefault(); moveCarousel(-1); }
      if (event.key === 'ArrowRight') { event.preventDefault(); moveCarousel(1); }
    });
    carousel?.addEventListener('scroll', () => {
      if (!carouselProgress) return;
      const maxScroll = Math.max(1, carousel.scrollWidth - carousel.clientWidth);
      const ratio = carousel.scrollLeft / maxScroll;
      const thumbRatio = Math.min(1, carousel.clientWidth / carousel.scrollWidth);
      carouselProgress.style.width = (thumbRatio * 100) + '%';
      carouselProgress.style.transform = 'translateX(' + (ratio * ((1 / thumbRatio) - 1) * 100) + '%)';
    }, { passive: true });
    const makeDraggable = (el) => {
      if (!el) return;
      let dragging = false;
      let moved = false;
      let dragStart = 0;
      let dragScroll = 0;
      el.addEventListener('pointerdown', (event) => {
        dragging = true;
        moved = false;
        dragStart = event.clientX;
        dragScroll = el.scrollLeft;
        el.classList.add('is-dragging');
      });
      el.addEventListener('pointermove', (event) => {
        if (!dragging) return;
        if (!moved && Math.abs(event.clientX - dragStart) > 6) {
          moved = true;
        }
        if (moved) {
          event.preventDefault();
          el.scrollLeft = dragScroll - (event.clientX - dragStart);
        }
      });
      const stop = () => {
        dragging = false;
        el.classList.remove('is-dragging');
      };
      el.addEventListener('pointerup', stop);
      el.addEventListener('pointercancel', stop);
      el.addEventListener('lostpointercapture', stop);
      el.addEventListener('dragstart', (event) => {
        event.preventDefault();
      });
      el.addEventListener('click', (event) => {
        if (moved) { event.preventDefault(); event.stopPropagation(); moved = false; }
      }, true);
    };

    makeDraggable(carousel);
    blogHub.querySelectorAll('.newsroom-blog-group__grid').forEach(makeDraggable);
    blogHub.querySelectorAll('.newsroom-blog__filter-list').forEach(makeDraggable);

    // Fade the sticky category nav out right when its container ends, so it
    // never lingers over the All articles section during fast scrolling.
    const filtersNav = blogHub.querySelector('[data-blog-filters]');
    const groupsArea = blogHub.querySelector('.newsroom-blog__groups-area');
    if (filtersNav && groupsArea && 'IntersectionObserver' in window) {
      const filterBar = filtersNav.querySelector('.newsroom-blog__filter-list');
      const navPassLine = (parseFloat(getComputedStyle(filtersNav).top) || 0) + ((filterBar && filterBar.offsetHeight) || 0);
      const navObserver = new IntersectionObserver((entries) => {
        const entry = entries[entries.length - 1];
        filtersNav.classList.toggle('is-passed', !entry.isIntersecting);
      }, { rootMargin: '-' + navPassLine + 'px 0px 0px 0px' });
      navObserver.observe(groupsArea);
    }

    // When the yellow nav sticks, collapse the breathing space above it so the
    // bar tucks right under the header; restore it when scrolling back up.
    if (filtersNav) {
      const navStickyTop = () => parseFloat(getComputedStyle(filtersNav).top) || 0;
      const updateNavStuck = () => {
        filtersNav.classList.toggle('is-stuck', filtersNav.getBoundingClientRect().top <= navStickyTop() + 1);
      };
      updateNavStuck();
      window.addEventListener('scroll', updateNavStuck, { passive: true });
      window.addEventListener('resize', updateNavStuck);
    }

    // Group "View All" links glide down to the All articles section instead of jumping.
    blogHub.querySelectorAll('.newsroom-blog-group__view-all').forEach((link) => {
      link.addEventListener('click', (event) => {
        const target = document.querySelector('#blog-all');
        if (!target) return;
        event.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        history.replaceState(null, '', '#blog-all');
      });
    });

    const applyFilter = (filter) => {
      if (groups.length) {
        groups.forEach((group) => {
          const hasArticles = group.querySelectorAll('.newsroom-blog-group-card').length > 0;
          group.hidden = !hasArticles;
          group.classList.remove('is-last-visible');
          const filterLink = filters.find((item) => item.dataset.blogFilter === group.dataset.blogGroup);
          if (filterLink) filterLink.hidden = !hasArticles;
        });
        groups.filter((group) => !group.hidden).at(-1)?.classList.add('is-last-visible');
        if (count) count.textContent = '';
        if (empty) empty.hidden = true;
        return;
      }
      let visible = 0;
      cards.forEach((card) => {
        const tags = (card.dataset.blogTags || '').toLowerCase();
        const title = (card.dataset.blogTitle || '').toLowerCase();
        const searchable = tags + ' ' + title;
        const matches = filter === 'all'
          || (filter === 'buying-guides' && /buying.?guide|guide|buy|choos|size/.test(searchable))
          || (filter === 'compare-batteries' && /compare|comparison|vs|versus/.test(searchable))
          || (filter === 'tips-tricks' && /tip|trick|how.?to|setup|install/.test(searchable))
          || (filter === 'troubleshooting' && /troubleshoot|maintenance|maintain|problem|error|fix|repair/.test(searchable))
          || (filter === 'knowledge' && /knowledge|education|battery|lifepo|energy|solar|power/.test(searchable))
          || (filter === 'applications' && /application|rv|marine|boat|camp|home|golf|ups|solar/.test(searchable))
          || (filter === 'product-reviews' && /product.?review|review|rating|test/.test(searchable))
          || (filter === 'news' && /(^|\s)news(\s|$)|launch|update|announcement|press/.test(searchable));
        card.hidden = !matches;
        if (matches) visible += 1;
      });
      filters.forEach((button) => {
        const active = button.dataset.blogFilter === filter;
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-pressed', active ? 'true' : 'false');
      });
      if (count) count.textContent = visible + (visible === 1 ? ' article' : ' articles');
      if (empty) empty.hidden = visible !== 0;
    };
    filters.forEach((button) => button.addEventListener('click', (event) => {
      filters.forEach((item) => item.classList.toggle('is-active', item === button));
      const href = button.getAttribute('href') || '';
      if (href.indexOf('#') !== 0) return;
      const target = document.getElementById(href.slice(1));
      if (!target) return;
      event.preventDefault();
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      history.replaceState(null, '', href);
    }));
    applyFilter('all');
    carousel?.dispatchEvent(new Event('scroll'));

    // View all archive: scroll reveal + filtering + paged loading.
    // Filtering sees every article: the remaining pagination pages are
    // prefetched into the grid, so a category/search covers all 162 articles
    // instead of just the first page.
    // Filtered results paginate 9 per page (3 rows of 3); when they fit in one
    // page the Next page button stays hidden.
    const archiveGrid = blogHub.querySelector('[data-blog-grid]');
    if (archiveGrid) {
      const loadMoreButton = blogHub.querySelector('[data-blog-load-more]');
      const searchInput = blogHub.querySelector('[data-blog-search-input]');
      const filterLoader = blogHub.querySelector('[data-blog-loader]');
      const paginationBar = blogHub.querySelector('[data-blog-pagination]');
      const pagesBox = blogHub.querySelector('[data-blog-pages]');
      const prevPageBtn = blogHub.querySelector('[data-blog-page-prev]');
      const pageForm = blogHub.querySelector('[data-blog-page-form]');
      const pageInput = blogHub.querySelector('[data-blog-page-input]');
      const totalCount = parseInt(archiveGrid.dataset.blogTotal || '0', 10);
      let archiveCards = [...archiveGrid.querySelectorAll('[data-blog-card]')];
      let searchQuery = '';
      let currentCategory = 'all';
      let loading = false;
      let allLoaded = false;
      let prefetchPromise = null;
      let filteredPage = 0;
      let allVisibleCount = 9;
      let awaitingFilter = false;
      let revealWatcher = null;

      const isFiltering = () => currentCategory !== 'all' || searchQuery.trim() !== '';

      // Scroll reveal: reveal visible pending cards in batches of 6 (2 rows).
      const revealBatch = (batchSize) => {
        let revealed = 0;
        for (const card of archiveCards) {
          if (revealed >= batchSize) break;
          if (!card.hidden && !card.classList.contains('is-revealed')) {
            card.classList.add('is-revealed');
            revealed += 1;
          }
        }
        return revealed;
      };

      const watchReveal = () => {
        if (revealWatcher) { revealWatcher.disconnect(); revealWatcher = null; }
        const nextPending = archiveCards.find((card) => !card.hidden && !card.classList.contains('is-revealed'));
        if (!nextPending) return;
        revealWatcher = new IntersectionObserver((entries) => {
          if (entries[0] && entries[0].isIntersecting) {
            revealWatcher.disconnect();
            if (revealBatch(6) > 0) watchReveal();
          }
        }, { rootMargin: '0px 0px 20% 0px' });
        revealWatcher.observe(nextPending);
      };

      archiveGrid.classList.add('reveal-ready');
      revealBatch(6);

      const computeMatches = () => {
        const q = searchQuery.trim().toLowerCase();
        const words = q ? q.split(/\s+/) : [];
        return archiveCards.filter((card) => {
          const section = (card.dataset.section || '').trim().toLowerCase();
          if (currentCategory !== 'all' && section !== currentCategory) return false;
          if (q) {
            const title = (card.dataset.blogTitle || '').toLowerCase();
            return words.every((word) => title.indexOf(word) !== -1);
          }
          return true;
        });
      };

      let matches = [];

      const render = () => {
        if (awaitingFilter) return;
        const filtering = isFiltering();
        if (filtering) {
          matches = computeMatches();
          const start = filteredPage * 9;
          const end = start + 9;
          archiveCards.forEach((card) => { card.hidden = true; });
          matches.forEach((card, index) => {
            const visible = index >= start && index < end;
            card.hidden = !visible;
            if (!visible) return;
            // Float the freshly filtered page in instead of showing it statically.
            card.classList.remove('is-revealed');
            card.style.transitionDelay = Math.min(index - start, 8) * 0.04 + 's';
            requestAnimationFrame(() => card.classList.add('is-revealed'));
            window.setTimeout(() => { card.style.transitionDelay = ''; }, 1400);
          });
        } else {
          // All view is a 9-card window too: show only the current page slice.
          const from = Math.max(0, allVisibleCount - 9);
          archiveCards.forEach((card, index) => { card.hidden = index < from || index >= allVisibleCount; });
        }
        if (empty) empty.hidden = !(filtering && matches.length === 0);
        updatePagination();
        watchReveal();
      };

      const fetchPageCards = async (nextUrl) => {
        const url = new URL(nextUrl, window.location.origin);
        if (loadMoreButton?.dataset.sectionId) url.searchParams.set('section_id', loadMoreButton.dataset.sectionId);
        const res = await fetch(url.toString());
        if (!res.ok) throw new Error('bad status');
        const html = await res.text();
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const newCards = [...doc.querySelectorAll('[data-blog-grid] [data-blog-card]')];
        const nextButton = doc.querySelector('[data-blog-load-more]');
        return { newCards, nextUrl: nextButton && nextButton.dataset.nextUrl ? nextButton.dataset.nextUrl : '' };
      };

      // Pull every remaining page into the grid (hidden until the current
      // view/filter makes them visible) so filtering sees all articles.
      const prefetchAll = () => {
        if (allLoaded) return Promise.resolve();
        if (!prefetchPromise) {
          prefetchPromise = (async () => {
            try {
              let nextUrl = loadMoreButton?.dataset.nextUrl || '';
              while (nextUrl) {
                const { newCards, nextUrl: following } = await fetchPageCards(nextUrl);
                newCards.forEach((card) => {
                  card.hidden = true;
                  archiveGrid.appendChild(card);
                });
                loadMoreButton.dataset.nextUrl = following;
                archiveCards = [...archiveGrid.querySelectorAll('[data-blog-card]')];
                nextUrl = following;
                render();
              }
              allLoaded = true;
              render();
            } catch (error) {
              // Keep whatever loaded; a later interaction retries.
            } finally {
              prefetchPromise = null;
            }
          })();
        }
        return prefetchPromise;
      };

      // Filter loading state: hide the grid and show the spinner until the full
      // result set is loaded, then render the first 9-card page at once.
      const showFilterLoading = () => {
        awaitingFilter = true;
        archiveGrid.classList.add('is-loading');
        if (filterLoader) filterLoader.hidden = false;
        if (empty) empty.hidden = true;
        if (paginationBar) paginationBar.hidden = true;
      };
      const hideFilterLoading = () => {
        awaitingFilter = false;
        archiveGrid.classList.remove('is-loading');
        if (filterLoader) filterLoader.hidden = true;
        render();
      };

      const loadNext = async () => {
        if (loading) return;
        if (isFiltering()) {
          filteredPage += 1;
          render();
          return;
        }
        const { current, totalPages } = pageState();
        if (current >= totalPages) return;
        loading = true;
        loadMoreButton?.setAttribute('disabled', 'disabled');
        try {
          await goToPage(current + 1);
        } finally {
          loading = false;
          loadMoreButton?.removeAttribute('disabled');
        }
      };

      loadMoreButton?.addEventListener('click', loadNext);

      // Page statistics: numbered pages (1 2 3 … N) around the Next page button,
      // 9 per page everywhere (3 rows of 3), plus a jump input.
      const pageState = () => {
        if (isFiltering()) {
          const totalPages = Math.max(1, Math.ceil(matches.length / 9));
          return { current: Math.min(Math.max(1, filteredPage + 1), totalPages), totalPages };
        }
        const totalPages = Math.max(1, Math.ceil(totalCount / 9));
        return { current: Math.min(Math.ceil(allVisibleCount / 9), totalPages), totalPages };
      };

      const buildPages = (current, totalPages) => {
        if (!pagesBox) return;
        pagesBox.textContent = '';
        const nums = [];
        if (totalPages <= 7) {
          for (let i = 1; i <= totalPages; i++) nums.push(i);
        } else {
          nums.push(1);
          if (current > 4) nums.push('…');
          for (let i = Math.max(2, current - 1); i <= Math.min(totalPages - 1, current + 1); i++) nums.push(i);
          if (current < totalPages - 3) nums.push('…');
          nums.push(totalPages);
        }
        nums.forEach((num) => {
          if (num === '…') {
            const span = document.createElement('span');
            span.className = 'newsroom-blog__page-ellipsis';
            span.textContent = '…';
            pagesBox.appendChild(span);
            return;
          }
          const btn = document.createElement('button');
          btn.type = 'button';
          btn.className = 'newsroom-blog__page' + (num === current ? ' is-active' : '');
          btn.textContent = num;
          btn.setAttribute('aria-label', 'Page ' + num);
          btn.addEventListener('click', () => goToPage(num));
          pagesBox.appendChild(btn);
        });
      };

      // Float a freshly shown window of cards in with a light stagger.
      const revealWindow = (from, to) => {
        archiveCards.slice(from, to).forEach((card, index) => {
          card.classList.remove('is-revealed');
          card.style.transitionDelay = Math.min(index, 11) * 0.03 + 's';
          requestAnimationFrame(() => card.classList.add('is-revealed'));
          window.setTimeout(() => { card.style.transitionDelay = ''; }, 1600);
        });
      };

      const goToPage = async (page) => {
        if (isFiltering()) {
          const totalPages = Math.max(1, Math.ceil(matches.length / 9));
          const clamped = Math.min(Math.max(1, page), totalPages);
          if (clamped === filteredPage + 1) return;
          filteredPage = clamped - 1;
          render();
          return;
        }
        const totalPages = Math.max(1, Math.ceil(totalCount / 9));
        const clamped = Math.min(Math.max(1, page), totalPages);
        const to = clamped * 9;
        const from = to - 9;
        if (to > archiveCards.length && !allLoaded) {
          // First jump ever: loading animation until every page is available.
          showFilterLoading();
          await prefetchAll();
          if (!allLoaded) { hideFilterLoading(); return; }
          allVisibleCount = to;
          hideFilterLoading();
          revealWindow(from, Math.min(to, archiveCards.length));
          return;
        }
        // Page turn in place: quick fade out, swap, float the new page in.
        archiveGrid.classList.add('is-paging');
        await new Promise((resolve) => setTimeout(resolve, 180));
        allVisibleCount = to;
        render();
        archiveGrid.classList.remove('is-paging');
        revealWindow(from, Math.min(to, archiveCards.length));
      };

      const updatePagination = () => {
        if (!paginationBar) return;
        const { current, totalPages } = pageState();
        const show = totalPages > 1;
        paginationBar.hidden = !show;
        if (!show) return;
        buildPages(current, totalPages);
        if (prevPageBtn) prevPageBtn.disabled = current <= 1;
        if (pageInput) pageInput.max = totalPages;
        // On the last page the Next page button stays put but greys out.
        const loadMoreWrap = loadMoreButton?.closest('.newsroom-blog__load-more');
        if (loadMoreWrap) loadMoreWrap.style.display = '';
        if (loadMoreButton) loadMoreButton.disabled = current >= totalPages;
      };

      prevPageBtn?.addEventListener('click', () => {
        const { current } = pageState();
        goToPage(current - 1);
      });
      pageForm?.addEventListener('submit', (event) => {
        event.preventDefault();
        const page = parseInt(pageInput?.value, 10);
        if (!Number.isNaN(page) && page >= 1) goToPage(page);
        if (pageInput) pageInput.blur();
      });

      let searchDebounce;
      searchInput?.addEventListener('input', () => {
        prefetchAll();
        clearTimeout(searchDebounce);
        searchDebounce = setTimeout(() => {
          searchQuery = searchInput.value;
          filteredPage = 0;
          render();
        }, 150);
      });

      // Category chips next to the search bar filter the grid by article section.
      const chips = [...blogHub.querySelectorAll('[data-blog-chip]')];
      chips.forEach((chip) => {
        chip.addEventListener('click', async (event) => {
          event.preventDefault();
          currentCategory = chip.dataset.blogChip || 'all';
          filteredPage = 0;
          chips.forEach((other) => other.classList.toggle('is-active', other === chip));
          if (currentCategory !== 'all' && !allLoaded) {
            showFilterLoading();
            await prefetchAll();
            hideFilterLoading();
          } else {
            render();
          }
          // If the grid top has scrolled out of view, bring it back so results are visible.
          if (archiveGrid.getBoundingClientRect().top < 0) {
            archiveGrid.scrollIntoView({ behavior: 'smooth', block: 'start' });
          }
        });
      });

      // Typewriter placeholder: types a phrase, deletes it, cycles to the next.
      // Stops only on click/touch or focus (hover keeps it typing); resumes on blur.
      const placeholderPhrases = ['Search "UPS"', 'Search "LiFePO4"', 'Search "NAS"', 'Search "solar"', 'Search "RV"', 'Search articles'];
      let phraseIndex = 0;
      let charIndex = 0;
      let deleting = false;
      let typeTimer = null;
      let typeAnimActive = true;

      const typeLoop = () => {
        if (!typeAnimActive || !searchInput) return;
        const phrase = placeholderPhrases[phraseIndex % placeholderPhrases.length];
        if (!deleting) {
          charIndex += 1;
          searchInput.placeholder = phrase.slice(0, charIndex);
          if (charIndex >= phrase.length) {
            deleting = true;
            typeTimer = setTimeout(typeLoop, 1300);
          } else {
            typeTimer = setTimeout(typeLoop, 85);
          }
        } else {
          charIndex -= 1;
          searchInput.placeholder = phrase.slice(0, charIndex);
          if (charIndex <= 0) {
            deleting = false;
            phraseIndex += 1;
            typeTimer = setTimeout(typeLoop, 350);
          } else {
            typeTimer = setTimeout(typeLoop, 45);
          }
        }
      };

      const stopTypeAnim = () => {
        typeAnimActive = false;
        clearTimeout(typeTimer);
        charIndex = 0;
        deleting = false;
        if (searchInput) searchInput.placeholder = '';
      };
      const resumeTypeAnim = () => {
        if (searchInput && !searchInput.value && !typeAnimActive) {
          typeAnimActive = true;
          typeLoop();
        }
      };

      searchInput?.addEventListener('pointerdown', stopTypeAnim);
      searchInput?.addEventListener('focus', stopTypeAnim);
      searchInput?.addEventListener('blur', resumeTypeAnim);

      typeLoop();

      render();
    }
  }

  // Scroll reveal for section content below the hero.
  const revealEls = root.querySelectorAll('[data-reveal]');
  if (revealEls.length) {
    if ('IntersectionObserver' in window) {
      const revealObserver = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-revealed');
            revealObserver.unobserve(entry.target);
          }
        });
      }, { threshold: 0.12, rootMargin: '0px 0px -6% 0px' });
      revealEls.forEach((el) => revealObserver.observe(el));
    } else {
      revealEls.forEach((el) => el.classList.add('is-revealed'));
    }
  }
})();
